export const DEFAULT_STUN = 'stun:stun.l.google.com:19302';

export interface IceEnv {
  readonly VITE_STUN_URLS?: string;
  readonly VITE_TURN_URLS?: string;
  readonly VITE_TURN_USERNAME?: string;
  readonly VITE_TURN_CREDENTIAL?: string;
}

export interface IceConfig {
  readonly iceServers: RTCIceServer[];
  /**
   * Sans TURN, certains réseaux (entreprise, 4G) bloqueront la connexion.
   * Risque connu, affiché dans l'UI en cas d'échec.
   */
  readonly hasTurn: boolean;
  readonly warnings: string[];
}

const split = (v: string): string[] =>
  v
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

/** Serveurs ICE à partir des variables d'environnement (lues au build par Vite). */
export function buildIceConfig(env: IceEnv): IceConfig {
  const warnings: string[] = [];
  const keep = (urls: string[], schemes: RegExp): string[] =>
    urls.filter((u) => {
      if (schemes.test(u)) return true;
      warnings.push(`URL ICE ignorée (schéma invalide) : ${u}`);
      return false;
    });

  const iceServers: RTCIceServer[] = [];
  const stun = keep(split(env.VITE_STUN_URLS ?? DEFAULT_STUN), /^stuns?:/);
  if (stun.length > 0) iceServers.push({ urls: stun });

  let hasTurn = false;
  const turn = keep(split(env.VITE_TURN_URLS ?? ''), /^turns?:/);
  if (turn.length > 0) {
    const { VITE_TURN_USERNAME: username, VITE_TURN_CREDENTIAL: credential } = env;
    if (username && credential) {
      iceServers.push({ urls: turn, username, credential });
      hasTurn = true;
    } else {
      warnings.push('TURN ignoré : VITE_TURN_USERNAME et VITE_TURN_CREDENTIAL requis');
    }
  }
  return { iceServers, hasTurn, warnings };
}
